import { Injectable } from '@angular/core';
import { ToolbarItemDisabledCheckInterface } from "./toolbar-item-disabled-check-factory.service";
import { ToolbarItemAbstractDisabledCheckService } from "./toolbar-item-abstract-disabled-check.service";
@Injectable()
export class ToolbarItemOpenQuestionnaireByPhoneProjectGroupDisabledCheckService extends ToolbarItemAbstractDisabledCheckService implements ToolbarItemDisabledCheckInterface {

  isDisabled(): boolean {
    let disabled = true;
    if ((this.entity && this.entity.hasOpenPhoneProject)) {
      disabled = false;
    }

    return this.isDisabledGlobally() || disabled;
  }

}
